export type AppEnv = 'staging' | 'production' | 'development';

function readMode(): AppEnv {
  const mode = typeof __APP_ENV__ === 'string' ? __APP_ENV__ : 'development';
  if (mode === 'staging' || mode === 'production') return mode;
  return 'development';
}

/** Which database this build edits. Comes from the Vite `--mode`, like the extension. */
export const APP_ENV: AppEnv = readMode();

export const ENV_LABEL: Record<AppEnv, string> = {
  staging: 'Staging',
  production: 'Production',
  development: 'Development',
};

export const SUPABASE_URL: string = import.meta.env.VITE_SUPABASE_URL || '';
export const SUPABASE_KEY: string =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY || '';

export const isConfigured = Boolean(SUPABASE_URL && SUPABASE_KEY);
